import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import IconSimilarHigh from '@/components/icons/IconSimilarHigh.vue';
import IconSimilarMiddle from '@/components/icons/IconSimilarMiddle.vue';
import IconSimilarLow from '@/components/icons/IconSimilarLow.vue';
import { useI18n } from '@/composables/use-i18n';
import _ from 'lodash';

enum ESimilarLevel {
    LOW = 'LOW',
    HIGH = 'HIGH',
    MIDDLE = 'MIDDLE'
}

enum ESimilarColor {
    LOW = 'pa-bg-green-40',
    MIDDLE = 'pa-bg-yellow-40',
    HIGH = 'pa-bg-red-40'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareSimilarTag',
  props: {
    similarity: null
  },
  setup(__props: any) {

const props = __props as {
    similarity: number,
}

const { t } = useI18n();


const ESimilarIcon = {
    LOW: IconSimilarLow,
    MIDDLE: IconSimilarMiddle,
    HIGH: IconSimilarHigh,
};

const percentage = computed(() => {
    return (+props.similarity * 100).toFixed(1);
});

/**
 * 不同相似度区分层级
 */
const level = computed(() => {
    if (+percentage.value >= 90) return ESimilarLevel.HIGH;
    if (+percentage.value >= 60 && +percentage.value < 90) return ESimilarLevel.MIDDLE;
    return ESimilarLevel.LOW;
});

/**
 * 图标
 */
const levelIcon = computed(() => {
    return _.get(ESimilarIcon, level.value);
});

/**
 * 背景色
 */
const levelBgColor = computed(() => {
    return _.get(ESimilarColor, level.value);
});


return { __sfc: true,t, props, ESimilarLevel, ESimilarColor, ESimilarIcon, percentage, level, levelIcon, levelBgColor }
}

})